import CommentsWidgetList from './CommentsWidgetList';
export default CommentsWidgetList;



// WEBPACK FOOTER //
// ./src/components/CommentsWidgetList/index.js